// extracted by mini-css-extract-plugin
export default {"error":"GlobalStyles_error__uQmla","blurEffect":"GlobalStyles_blurEffect__aJT35"};